import {
  extractSelectedTicketIdFromState,
  extractSelectedTicketFromState,
  isAccountUser as getIsAccountUser,
} from 'extractFromState';
import { liveQuerySubscribeLock, LIVE_QUERY_SUBSCRIBE_LOCK_KEY } from 'util/asyncLocks';
import {
  MESSAGE_CREATE_SUBSCRIPTION,
  MESSAGE_UPDATE_SUBSCRIPTION,
  MESSAGE_ENTER_SUBSCRIPTION,
} from './messageSubscriptions.gql';
import subscribeToLiveQuery from '../subscribeToLiveQuery';
import { addMessageToConversation, updateMessage } from 'actions';

let subscriptions = [];
let subscribedConversationId = null;
const startConversationLiveQuery = (store, conversationObjId) => {
  // This if condition may not be required anymore as LOAD_CONVERSATION action should never be dispatched with empty conversationObjectId
  conversationObjId ??= extractSelectedTicketIdFromState(store.getState());

  if (!conversationObjId) {
    return;
  }

  // Un-subscribing to the old conversation if old ConversationObjId doesn't match the new conversationObjId
  if (subscribedConversationId && subscribedConversationId !== conversationObjId) {
    subscriptions.forEach((s) => s?.unsubscribe());
    subscribedConversationId = null;
    subscriptions = [];
  }

  if (!subscribedConversationId) {
    liveQuerySubscribeLock.acquire(LIVE_QUERY_SUBSCRIBE_LOCK_KEY, async (lockDoneFunction) => {
      const state = store.getState();
      const ticket = extractSelectedTicketFromState(state);
      const simplrAccountId = ticket?.simplrAccountPtrId;
      const _isAccountUser = getIsAccountUser(state);

      const variables = {
        filter: {
          conversationId: {
            eq: conversationObjId,
          },
          ...(_isAccountUser && simplrAccountId && { simplrAccountId: { eq: simplrAccountId } }),
        },
      };

      const handleOnCreateMessage = (message) => {
        /*
         *  This event will be triggered when a new message is added to the existing conversation,
         *  usually when customer sends a new message or an Expert Send's Message or Add's Note.
         */
        store.dispatch(addMessageToConversation(message));
      };

      const handleOnEnterMessage = (message) => {
        /*
         *  This event will be triggered when a new message is added to the existing conversation,
         *  usually when customer sends a new message or an Expert Send's Message or Add's Note.
         */
        store.dispatch(addMessageToConversation(message));
      };

      const handleOnUpdateMessage = (message) => {
        store.dispatch(updateMessage(message));
      };

      const createSubscription = subscribeToLiveQuery(
        MESSAGE_CREATE_SUBSCRIPTION,
        variables,
        'onCreateMessage',
        handleOnCreateMessage
      );

      const enterSubscription = subscribeToLiveQuery(
        MESSAGE_ENTER_SUBSCRIPTION,
        variables,
        'onEnterMessage',
        handleOnEnterMessage
      );

      const updateSubscription = subscribeToLiveQuery(
        MESSAGE_UPDATE_SUBSCRIPTION,
        variables,
        'onUpdateMessage',
        handleOnUpdateMessage
      );

      subscriptions.push(createSubscription, updateSubscription, enterSubscription);

      // TODO: figureout if connection established
      subscribedConversationId = conversationObjId;
      lockDoneFunction();
    });
  }
};

export { startConversationLiveQuery };
